import { combineEpics } from 'redux-observable'
import { createInvokeEpic } from '../../signalr/createInvokeEpic'
import {
  createOrUpdateAlertFilterDefinition,
  deleteAlertFilterDefinition,
  fetchAlertFiltersDefinition,
  muteAlertFilterDefinition
} from './definition'

export default combineEpics(
  createInvokeEpic(
    'alertFilter.fetchAlertFilters',
    fetchAlertFiltersDefinition
  ),
  createInvokeEpic(
    'alertFilter.createOrUpdate',
    createOrUpdateAlertFilterDefinition
  ),
  createInvokeEpic(
    'alertFilter.deleteAlertFilter',
    deleteAlertFilterDefinition
  ),
  createInvokeEpic('alertFilter.muteAlertFilter', muteAlertFilterDefinition)
)
